import Avatar from '@mui/material/Avatar'
import PS2Logo from '../images/icons/Logo.svg'
import Id from '../images/icons/id.gif'
import Story from '../images/icons/book.gif'
import Messenger from '../images/icons/social-media.gif'
import HugsCount from '../images/icons/hug.svg'
import SupportMsg from '../images/icons/message.svg'
import SupportMsg2 from '../images/icons/message2.svg'
import Send from '../images/icons/send.svg'
import Hugged from '../images/icons/hugged.svg'
import Connected from '../images/icons/connected.svg'
import Delete from '../images/icons/delete.svg'

const Logo = (props) => <img {...props} src={PS2Logo} alt="app-logo" />

const ProfileCardIcon = (props) => <img {...props} src={Id} alt="profile-tab-icon" />
const StoryIcon = props => <img {...props} src={Story}  alt="story-tab-icon" />
const MessengerIcon = props => <img {...props} src={Messenger}  alt="messenger-tab-icon" />

const HugsCountIcon = props => <img {...props} src={HugsCount}  alt="hugs-count-icon" />
const SupportMsgIcon1 = props => <img {...props} src={SupportMsg}  alt="support-message-1-icon" />
const SupportMsgIcon2 = props => <img {...props} src={SupportMsg2}  alt="support-message-2-icon" />

const HuggedCountIcon = props => <img {...props} src={Hugged}  alt="hugged-icon" />
const ConnectedIcon = props => <img {...props} src={Connected}  alt="connected--icon" />

const SendIcon = props => <img {...props} src={Send}  alt="send-icon" />
const DeleteIcon = props => <img {...props} src={Delete}  alt="delete-icon" />

export { 
    Logo,
    ProfileCardIcon,
    StoryIcon,
    MessengerIcon,
    HugsCountIcon,
    SupportMsgIcon1,
    SupportMsgIcon2,
    SendIcon,
    HuggedCountIcon,
    ConnectedIcon,
    DeleteIcon
}